import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function useSuggest(q, scope, enabled = true) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = q.trim();
    if (!enabled || t.length < 2) { setItems([]); return undefined; }
    let live = true;
    const h = setTimeout(() => api.get("/search/suggest", { params: { q: t, scope } }).then(({ data }) => live && setItems(data.items)).catch(() => live && setItems([])), 250);
    return () => { live = false; clearTimeout(h); };
  }, [q, scope, enabled]);
  return items;
}

export const fillLast = (q, text) => [...q.trim().split(/\s+/).slice(0, -1), text].filter(Boolean).join(" ");

export const SuggestList = ({ items, active, onPick, testid }) => (
  <div className="absolute z-50 left-0 right-0 top-full mt-1 rounded-md border border-slate-200 bg-white shadow-xl" data-testid={`${testid}-suggest`}>
    <div className="px-3 pt-2 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Öneriler</div>
    {items.map((s, i) => (
      <button key={s.text} type="button" onMouseDown={(e) => { e.preventDefault(); onPick(s); }} data-testid={`${testid}-suggest-${i}`}
        className={`flex w-full items-center justify-between px-3 py-1.5 text-left text-[13px] transition-colors ${i === active ? "bg-blue-50" : "hover:bg-slate-50"}`}>
        <span>{s.text}</span><span className="font-mono text-[11px] text-slate-400">{s.count}</span>
      </button>
    ))}
  </div>
);

export default function SuggestInput({ value, onChange, scope, className = "", placeholder, testid }) {
  const items = useSuggest(value, scope);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const blurT = useRef(null);
  useEffect(() => setActive(-1), [items]);
  const pick = (s) => { onChange(fillLast(value, s.text)); setOpen(false); };
  const onKey = (e) => {
    if (!open || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => Math.min(a + 1, items.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => Math.max(a - 1, 0)); }
    else if (e.key === "Enter" && active >= 0) { e.preventDefault(); pick(items[active]); }
    else if (e.key === "Escape") setOpen(false);
  };
  return (
    <div className={`relative ${className}`}>
      <input value={value} placeholder={placeholder} onKeyDown={onKey} data-testid={testid}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => { clearTimeout(blurT.current); setOpen(true); }} onBlur={() => { blurT.current = setTimeout(() => setOpen(false), 150); }}
        className="h-9 w-full rounded-md border border-slate-300 bg-white px-3 text-sm focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/30" />
      {open && items.length > 0 && <SuggestList items={items} active={active} onPick={pick} testid={testid} />}
    </div>
  );
}
